import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const Wrapper = styled.div`
  width: 100%;
`;

export const Title = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: ${layout.spacing.small};
`;
